import React from 'react';
import data from './data';

const RegisterTrustFactors = () => (
  <div className="trustFactors">
    {data?.icons.map((icon) => (
      <img
        className="trustFactors__item"
        src={icon.src}
        alt={icon.alt}
        title={icon.title}
        key={icon.title}
      />
    ))}
  </div>
);

export default RegisterTrustFactors;
